package com.narbase.letsgo.dto.core

import com.narbase.letsgo.dto.EnumDtoName

enum class GenderDto(override val dtoName: String) : EnumDtoName { Male("Male"), Female("Female"); }
